import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { observer } from "mobx-react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import TableColumnProperties from "../TableColumnProperties"
import ToolFieldPropertiesHeaderWithContent from "../ToolFieldPropertiesHeaderWithContent"

interface Props {}

const RequestTableForm = observer(({}: Props) => {
	const formStore = useFormStore()
	const { t } = useTranslation()

	const [isSectionHidden] = useState<{ [k: string]: boolean }>({})
	const [refreshCount, refresh] = useState(0)

	const toggleIsSectionHidden = (fieldKey: string) => {
		isSectionHidden[fieldKey] = !!!isSectionHidden[fieldKey]
		refresh((count) => count + 1)
	}

	return (
		<HyperDiv direction="column" spaceBetweenElems="2rem">
			{formStore.selectedFormsConfig?.requestTable.map((data, i) => {
				const { mainFieldKey, mainFieldLabel, nameLV, nameEN } = data
				// ! TECHNICAL DEBT: 3184, replace this with dynamic key ([parsedkey])
				let isEN = formStore.requestTableLanguage === "en"

				const handleLanguageSelect = (nameText: string | undefined) => {
					if (isEN) {
						formStore.mergeRequestTableFormData(i, {
							nameEN: nameText,
						})
					} else {
						formStore.mergeRequestTableFormData(i, {
							nameLV: nameText,
						})
					}
				}

				return (
					<ToolFieldPropertiesHeaderWithContent
						key={i + mainFieldKey}
						label={mainFieldLabel}
						selectedLanguage={formStore.requestTableLanguage}
						titleInputValue={isEN ? nameEN : nameLV}
						titleInputPlaceholder={t("rawText.columnName")}
						buttonColors={formStore.settingsData.personalize}
						isContentHidden={isSectionHidden[mainFieldKey]}
						onClickMoveUp={() => formStore.moveFieldInForm("requestTable", i, i - 1)}
						onClickMoveDown={() => formStore.moveFieldInForm("requestTable", i, i + 1)}
						onClickRemove={() => formStore.deleteFormField("requestTable", i)}
						onClickLabel={() => toggleIsSectionHidden(mainFieldKey)}
						onChangeFormData={({ nameText }) => {
							handleLanguageSelect(nameText)
						}}
						tooltipInputHidden
					>
						<TableColumnProperties
							value={data}
							onChangeFormData={(data) => {
								formStore.mergeRequestTableFormData(i, data)
							}}
						/>
					</ToolFieldPropertiesHeaderWithContent>
				)
			})}
		</HyperDiv>
	)
})

export default RequestTableForm
